// extracted by mini-css-extract-plugin
export default {"area":"ContentLayer_area__TUDZ0","search-indicator":"ContentLayer_search-indicator__Sbxc0"};